import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Box, Flex } from 'reflexbox';

import { Button } from '../../../../components/Marketing/Button/index';
import image2 from './images/image2.png';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

const Container = styled(Flex)`
  flex-direction: column-reverse;
  margin-top: 40px;
  margin-bottom: 40px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    flex-direction: initial;
  }
`;

const SubContainer = styled(Flex)`
  flex-direction: column;
  padding: 15px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    // padding-left: 30px;
    width: 50%;
  }
`;

const ImageHolder = styled(Flex)`
  flex-direction: column;
  padding-left: 0px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    padding: 15px;
    width: 50%;
  }
  img {
    width: 100%;
    height: auto;
  }
`;

const ContainerInner = styled.div`
  max-width: 960px;
  width: 100%;
  flex-direction: row;
  display: flex;
  // padding: 2px;
  margin-bottom: 40px;
  @media only screen and (min-width: 960px) {
    padding: 12px;
    > div {
      width: 50%;
    }
    > img {
      width: 50%;
    }
    margin-bottom: 0px;
  }
  img {
    display: none;
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      display: block;
    }
  }
`;

const ButtonContainer = styled(Flex)`
  justify-content: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: start;
  }
`;

const Label = styled(Box)({
  fontWeight: 900,
  fontSize: '14px',
  lineHeight: '130%',
  color: '#B0B6C2',
  paddingBottom: '12px',
});

const SectionHeading = styled(Box)({
  fontWeight: 900,
  fontSize: '36px',
  lineHeight: '120%',
  letterSpacing: '-0.01em',
  color: '#041416',
  paddingBottom: '24px',
});

const SectionDescription = styled(Box)({
  fontWeight: 'normal',
  fontSize: '16px',
  lineHeight: '140%',
  color: '#7C8788',
  paddingBottom: '24px',
});

export const EngageAndLearn = (): ReactElement => {
  return (
    <Container>
      <ContainerInner>
        <ImageHolder>
          <img alt="" src={image2} />
        </ImageHolder>
        <SubContainer>
          <Label>ANYWHERE &amp; ANYTIME</Label>
          <SectionHeading>Engage and learn with peers worldwide</SectionHeading>
          <SectionDescription>
            Experience well designed activity-based learning, collaborative
            projects, and a supportive community, all made possible by the
            OpenLearning platform.
          </SectionDescription>
          <ButtonContainer>
            <Button
              variant="primary"
              action={{
                kind: 'external_link',
                value: 'https://solutions.openlearning.com/platform-features/',
                target: '_blank',
              }}
            >
              Learn more about our platform
            </Button>
          </ButtonContainer>
        </SubContainer>
      </ContainerInner>
    </Container>
  );
};
